import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useVerifyCodeStore } from '@lib/store';
import { useMediaQuery, useRouteHook } from '@shared/hooks';
import { cn, LocalStorageUtils, RoutePaths } from '@shared/utils';
import { ErrorLoginCodeModal } from './widgets';
import { Footer } from '@widgets/footer';
import { Button, CodeInput } from '@shared/widgets';
import logoImg from '@assets/images/logo.png';
import bgImg from '@assets/images/auth/bg-01.png';

export const LoginCodePage = () => {
  const verifyCodeStore = useVerifyCodeStore();

  const [otpValue, setOTPValue] = useState<string>('');

  const { navigate } = useRouteHook();
  const isMaxMd = useMediaQuery('(max-width: 768px)');

  const sendForm = async () => {
    await verifyCodeStore.verifyCode({ code: otpValue });
  };

  useEffect(() => {
    if (verifyCodeStore.success) {
      if (verifyCodeStore.userData?.token && !verifyCodeStore.userData?.secondFactorEnabled && verifyCodeStore.userData?.refreshToken) {
        LocalStorageUtils.setStuff({ ...verifyCodeStore.userData! });
        !isMaxMd ? navigate(RoutePaths.home.onNavigate()) : navigate(RoutePaths.cards.onNavigate());
      }
    }
  }, [verifyCodeStore]);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Enter') sendForm();
    };

    document.addEventListener('keypress', handleKeyPress);
    verifyCodeStore.resetErrors();

    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, []);

  return (
    <>
      <div className='absolute top-[10px] left-[67px] z-[16] h-[50px] w-[50px] max-md:top-0 max-md:left-0 max-md:z-[10] max-md:w-full max-md:bg-[#0f0f114d]'>
        <NavLink className='mx-auto flex h-[50px] w-[50px] items-center justify-center max-md:h-[44px]' to={RoutePaths.home.onNavigate()}>
          <img className='h-full w-full object-contain' src={logoImg} alt='logo' />
        </NavLink>
      </div>
      <div className='mx-auto flex h-[702px] max-w-[1440px] overflow-hidden max-md:relative max-md:z-[1] max-md:h-auto max-md:w-full max-md:flex-col-reverse'>
        <div className='relative z-[99] w-[140px] max-md:hidden' />
        <div
          className={cn(
            'relative z-99 h-[702px] w-full bg-right bg-no-repeat pl-37.5 text-left',
            'max-md:h-auto max-md:bg-size-[auto_70%] max-md:bg-position-[center_-85%] max-md:pt-[100%] max-md:pl-0',
          )}
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <div className='w-[590px] max-md:relative max-md:w-full max-md:px-4 max-md:pt-5 max-md:pb-12'>
            <h2 className='mt-[103px] font-[Prata] text-[56px] text-[#272727] max-md:mt-0 max-md:text-center max-md:text-[28px]'>Authentication</h2>
            <div className='flex w-fit flex-col items-center justify-center'>
              <p className='mt-7.5 w-[394px] text-center text-lg font-medium text-[#000000] max-md:w-full max-md:text-[#4c4c4c80]'>
                Master Key has generated a one-time confirmation code, please insert it below to login.
              </p>
              <div className='mt-4 w-[294px] text-center max-md:w-full'>
                <label className='mb-2.5 block text-sm text-[#88888b] max-md:text-base'>Confirmation Code:</label>
                <CodeInput isFocus onComplete={setOTPValue} />
                {verifyCodeStore.error && (
                  <div className='mt-8 flex items-baseline gap-1 max-md:hidden'>
                    <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                    <div className='text-xs font-bold text-[#d0021b] uppercase'>{verifyCodeStore.error}</div>
                  </div>
                )}
                <div
                  className='mt-4 cursor-pointer text-xs font-medium text-[#272727] uppercase hover:underline max-md:text-base max-md:normal-case'
                  onClick={() => navigate(RoutePaths.masterKey.onNavigate())}
                >
                  Problems with my Master Key code
                </div>
              </div>
              <Button className='mt-5 w-[292px] max-md:mt-8 max-md:w-full' isLoading={verifyCodeStore.loading} onClick={sendForm}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ErrorLoginCodeModal />
    </>
  );
};
